import {IUsefulLinkConfiguration} from "../configurations/config-data-sections/drawer.configuration";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {Check} from "@sparkware/app-utils";
import {AppIdentifiers, AreaType} from "@sparkware/uc-sdk-core";
import {OPEN_SAFEZONE_SOURCE_VALUES} from "../safezone/safezone.service.interface";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../common/const/casinofied-analytics-consts";
import {MyAccountTab} from "../external-links/handlers/my-account/my-account.external-link-handler.interface";
import {ControlCenterDeeplink} from "@sparkware/uc-sdk-core";
import {CashierSessionTypes} from "../../../common/const/cashier-session-types";


export default class UsefulLinkActions {
  private services: IServiceFactoryExtended;

  constructor(serviceFactory: IServiceFactoryExtended) {
    this.services = serviceFactory;
  }

  public executeAction(link: IUsefulLinkConfiguration) {
    // Handlers are instance methods of `this` named 'on[LinkId]'
    const handler = this._findHandler(link.id);
    if(handler) {
      handler.call(this, link);
    }
  }

  private _findHandler(linkId: string): (link: IUsefulLinkConfiguration) => void {
    if(!linkId || linkId.length < 1) {
      return null;
    }

    const handlerName = 'on' + linkId.charAt(0).toUpperCase() + linkId.slice(1);
    if(Check.isFunction(this[handlerName])) {
      return this[handlerName];
    }

    return null;
  }

  onTransactionHistory() {
    this.services.cashier.openTransactionHistory(
      {
        channel: {
          source: CHANNEL_SOURCE.casinoClient,
          area: AreaType.UserArea,
          element: CHANNEL_ELEMENTS.transactionHistoryButton
        }
      }
    )
  }

  onTippingHistory(link: IUsefulLinkConfiguration) {
    this.services.location.push(link.link);
  }

  onReverseWithdrawal() {
    this.services.cashier.openOldCashier({sessionType: CashierSessionTypes.ReverseWithdrawal});
  }

  onUploadDocuments() {
    this.services.cashier.openOldCashier({sessionType: CashierSessionTypes.VERIFY_ID});
  }

  onCompPoints() {
    this.services.externalLinks.openMyAccount({
      tabId: MyAccountTab.ComPoints
    });
  }

  onContactUs(link: IUsefulLinkConfiguration) {
    this.services.externalLinks.openContactUs();
  }

  onHelpCenter(link: IUsefulLinkConfiguration) {
    this.services.appLauncher.openContactUs({
      businessCorrelationID: this.services.tools.getGuid(),
      channel: {
        area: AreaType.NavigationMenu,
        element: AppIdentifiers.CRHelpCenter,
        source: AppIdentifiers.CasinoClient
      }
    });
  }

  on888club(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onBeGambleAware(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onGameCare(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onSafeZone(link: IUsefulLinkConfiguration) {
    this.services.appLauncher.openControlCenterFull({
      businessCorrelationID: this.services.tools.getGuid(),
      channel: {
          area: AreaType.UserArea,
          element: CHANNEL_ELEMENTS.safezoneUsefulLink,
          source: CHANNEL_SOURCE.casinoClient
      },
      appSpecificParameters: {
          source: OPEN_SAFEZONE_SOURCE_VALUES.USER_AREA
      }
    });

  }

  onTimeSpentReminder(link: IUsefulLinkConfiguration) {
    this.services.appLauncher.openControlCenterFull({
      businessCorrelationID: this.services.tools.getGuid(),

      channel: {
        area: AreaType.UserArea,
        element: CHANNEL_ELEMENTS.safezoneUsefulLink,
        source: CHANNEL_SOURCE.casinoClient
      },
      appSpecificParameters: {
          deeplink: ControlCenterDeeplink.TimeSpentReminderPage,
          source: OPEN_SAFEZONE_SOURCE_VALUES.USER_AREA
      }
    });
  }

  onHelp() {
    this.services.externalLinks.openHelpPage();
  }


  private _openLinkAction({local:shouldOpenLocal, link}: IUsefulLinkConfiguration){
    if(shouldOpenLocal) {
      this.services.location.push(link);
    } else {
      this.services.externalLinks.openLink({
        sourceLink: link,
        view: 'window'
      })
    }
  }
}
